// extracted by mini-css-extract-plugin
module.exports = {"searchSegment":"FavoritesSearchBar_searchSegment__2owOC","searchInput":"FavoritesSearchBar_searchInput__uXWKm","checkboxes":"FavoritesSearchBar_checkboxes__C6eov"};